import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  isOpen: boolean
  onClose: () => void
  onDelete: () => Promise<void>
  extensionName: string
  isLoading: boolean
}

const DeleteDialog: React.FC<Props> = ({
  isOpen,
  onClose,
  onDelete,
  extensionName,
  isLoading,
}) => {
  const { t } = useTranslation()

  const handleDelete = async () => {
    try {
      await onDelete()
      onClose()
    } catch (error) {
      // Error handling is done in parent component
      console.error('Error deleting extension:', error)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {t('delete_saved_extension', 'Delete saved extension')}
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Text color="appBattleshipGrey">
            {t(
              'confirm_delete_saved_extension',
              'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
              { name: extensionName },
            )}
          </Text>
        </ModalBody>

        <ModalFooter borderTop="1px solid #e7eaf0" style={{ gap: '1em' }}>
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            {t('cancel', 'Cancel')}
          </Button>
          <Button
            colorScheme="appRed"
            onClick={handleDelete}
            isLoading={isLoading}
          >
            {t('delete', 'Delete')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default DeleteDialog
